export const profile = {
  Profile: "Profile",
  ProfileDesc: "View and edit your profile details.",
  ProfileImageDesc: "Change your profile image.",
} as const;
